<template>
  <div>
    <template>
      <h5 class="fw-600 gray-800 d-flex justify-content-between align-items-end" >
        <span v-if="show_title">
          {{ selected_lang != 'ENG' ? data_table_data?.title : data_table_data.translated?.title_e }}
        </span>
        <span v-if="data_table_data?.unit || data_table_data?.translated?.unit_e" class="fw-400 f-90 text-muted ml-auto">
          {{
            force_lang != 'ENG' ? data_table_data?.unit : data_table_data?.translated?.unit_e
          }}
        </span>
      </h5>
      <div class="mb-4">
        <b-table-simple v-if="selected_lang != 'ENG'" responsive
        :class="selected_lv2?.appendix_type === 'GRI' ? 'sb-write-table' : 'edi-table'">
          <b-thead :class="{ invisible: hideHeader(data_table_data.id) }">
            <b-tr>
              <b-td 
                v-for="(property, col_index) in data_table_data.header" 
                :key="col_index"
                 :style="getHeaderStyle(col_index)"
                class="custom-thead-td" 
              >
                <span 
                    v-html="formattedText(property)">
                </span>
              </b-td>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr v-for="(cells, rowIndex) in visibleRowCells" :key="rowIndex">
              <b-td
                v-for="cell in cells"
                :key="cell.colIndex"
                :colspan="cell.colspan"
                :rowspan="cell.rowspan"
                :style="cell.style"
              >
                <span v-html="formattedText(cell.value)"></span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <b-table-simple v-else responsive :class="selected_lv2?.appendix_type === 'GRI' ? 'sb-write-table' : 'edi-table'">
          <template v-if="data_table_data.translated?.header_e">
            <b-thead :class="{ invisible: hideHeader(data_table_data.id || data_table_data?.translated.id, 'ENG') }">
              <b-tr>
                <b-td 
                  v-for="(property, property_index) in data_table_data.translated?.header_e" 
                  :key="property_index"
                  :style="getHeaderStyle(property_index)"
                >
                    <span v-html="formattedText(property)"> </span>
                </b-td>
              </b-tr>
            </b-thead>

            <b-tbody>
              <b-tr v-for="(cells, rowIndex) in visibleRowCells" :key="rowIndex">
                <b-td
                  v-for="(cell) in cells"
                  :key="cell.colIndex"
                  :colspan="cell.colspan"
                  :rowspan="cell.rowspan"
                  :style="cell.style"
                >
                  <span v-html="formattedText(cell.value)"></span>
                </b-td>
              </b-tr>
            </b-tbody>
          </template>
        </b-table-simple>

        <p v-if="data_table_data.footnote || data_table_data?.translated?.footnote_e" class="fw-400 f-90 mb-0 text-muted" style="white-space: pre-line">
          {{ selected_lang != 'ENG' ? data_table_data.footnote : data_table_data?.translated?.footnote_e }}
        </p>
      </div>
    </template>

<!-- 
    <template v-else>
      <b-row>
        <b-col cols="2" v-if="show_title">
          <h6 class="mb-3 fw-600 gray-800 border-top-dark pt-2">
            {{ selected_lang != 'ENG' ? data_table_data?.title : data_table_data.translated?.title_e }}
          </h6>
        </b-col>
        <b-col cols="10" :offset="show_title ? 0 : 2" >
          <div class="mb-4">
            <b-table-simple v-if="selected_lang != 'ENG'" responsive
            :class="selected_lv2?.appendix_type === 'GRI' ? 'sb-write-table' : 'edi-table'">
              <b-thead :class="{ invisible: hideHeader(data_table_data.id) }">
                <b-tr>
                  <b-td 
                    v-for="(property, col_index) in data_table_data.header" 
                    :key="col_index"
                    :style="getHeaderStyle(col_index)"
                    class="custom-thead-td" 
                  >
                    <span 
                        v-html="formattedText(property)">
                    </span>
                  </b-td>
                </b-tr>
              </b-thead>
    
              <b-tbody>
                <b-tr v-for="(cells, rowIndex) in visibleRowCells" :key="rowIndex">
                  <b-td
                    v-for="cell in cells"
                    :key="cell.colIndex"
                    :colspan="cell.colspan"
                    :rowspan="cell.rowspan"
                    :style="cell.style"
                  >
                    <span v-html="formattedText(cell.value)"></span>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
    
            <b-table-simple v-else responsive :class="selected_lv2?.appendix_type === 'GRI' ? 'sb-write-table' : 'edi-table'">
              <template v-if="data_table_data.translated?.header_e">
                <b-thead :class="{ invisible: hideHeader(data_table_data.id || data_table_data?.translated.id, 'ENG') }">
                  <b-tr>
                    <b-td 
                      v-for="(property, col_index) in data_table_data.translated?.header_e" 
                      :key="col_index"
                      :style="getHeaderStyle(col_index)"
                    >
                    
                        <span v-html="formattedText(property)"> </span>
                    </b-td>
                  </b-tr>
                </b-thead>
    
                <b-tbody>
                  <b-tr v-for="(cells, rowIndex) in visibleRowCells" :key="rowIndex">
                    <b-td
                    v-for="cell in cells"
                      :key="cell.colIndex"
                      :colspan="cell.colspan"
                      :rowspan="cell.rowspan"
                      :style="cell.style"
                    >
                      <span v-html="formattedText(cell.value)"></span>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
            </b-table-simple>
            
      

        <p v-if="( data_table_data?.footnote || data_table_data?.unit )" class="fw-400 f-90 mb-0 text-muted d-flex justify-content-between w-100" style="white-space: pre-line">
          <span>
            {{ selected_lang != 'ENG' ? data_table_data.footnote : data_table_data?.translated?.footnote_e }}
          </span>
          <span class="fw-400 f-90 text-muted ml-auto">
            {{
              selected_lang != 'ENG' ? data_table_data?.unit : data_table_data?.translated?.unit_e
            }}
          </span>

        </p>
        
      </div>
        </b-col>
      </b-row>

    </template> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { formattedText } from '@/components/util';
import { gri_mixin } from '@/components/writing_report/write_report_subs/gri_mixin';

export default {
  name: 'DataTableSb',
  mixins: [gri_mixin],
  props: {
    print_mode: { type: Boolean, default: false },
    show_title: { type: Boolean, default: true },
    force_lang: { type: String, default: '' },
    data_table_data: {
      type: Object,
      default: () => ({}), 
    },
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('story_board', ['selected_lv2']),
    ...mapGetters('report_contents', ['data_table_header_style', 'data_table_cell_style']),
    selected_lang() {
      if (this.force_lang !== '') {
        return this.force_lang
      } else {
        return this.lang
      }
      
    },
    visibleRowCells() {
      if (this.selected_lang === 'ENG' && !this.data_table_data.translated) {
        return [];
      }
      const hideHeaderVar = this.hideHeader(this.data_table_data.id);

      const contents = this.selected_lang !== 'ENG'
        ? this.data_table_data.contents
        : this.data_table_data.translated?.contents_e;

      const header = this.selected_lang !== 'ENG'
        ? this.data_table_data.header
        : this.data_table_data.translated?.header_e;

      const metaSource = this.selected_lang !== 'ENG'
        ? this.data_table_data.options
        : this.data_table_data.translated?.options_e;
      
      if (!contents || !header) {
        return [];
      }
      const cells = contents.map((row, r) =>
        header.map((prop, c) => {
          const key = `${r}, ${c}`;
          const isHeader = false; // header는 다르게 쓰네...

          const baseStyle = isHeader ? this.data_table_header_style : this.data_table_cell_style;

          const meta = metaSource?.[key] || {};

          // const widthValue = meta.width ?? headerMeta.width ?? (100 / header.length).toFixed(2);

          // 병합 순서: base → style → meta → headerMeta (meta 우선)
          const mergedStyle = {
            ...baseStyle,
            ...meta,
          };

          const [top, bottom, left, right] = mergedStyle.borderSide;


          return {
            rowIndex: r,
            colIndex: c,
            value: row[prop],
            colspan: mergedStyle.colspan ?? 1,
            rowspan: mergedStyle.rowspan ?? 1,
            hidden:  mergedStyle.hidden  ?? false,
            style: {
              ...mergedStyle,
              'border': `${mergedStyle.borderWidth}px ${mergedStyle.borderType} ${mergedStyle.borderColor} !important`,
              'border-top': `${top ? 1 : 0} !important`,
              'border-bottom': `${bottom ? 1 : 0} !important`,
              'border-left': `${left ? 1 : 0} !important`,
              'border-right': `${right ? 1 : 0} !important`,
              'backgroundColor': `${mergedStyle.backgroundColor} !important`,
              verticalAlign: mergedStyle.verticalAlign ?? 'top',
              textAlign: mergedStyle.textAlign ?? 'start',
              width: hideHeaderVar ? metaSource?.[`-1, ${c}`]?.width + "%" : 'auto',
            },
          };
        })
      );

      // 1열 병합: 값 연속성과 meta.rowspan 중 최대값 사용
      for (let r = 0; r < cells.length; r++) {
        const cell = cells[r][0];
        if (cell.hidden) continue;

        // 값 기준 병합 길이 계산
        let valueSpan = 1;
        for (let r2 = r + 1; r2 < cells.length; r2++) {
          const next = cells[r2][0];
          if (!next.hidden && next.value === cell.value) {
            valueSpan++;
          } else {
            break;
          }
        }

        // style.rowspan 메타 가져오기
        const meta     = metaSource?.[`${r}, 0`] || {};
        const styleSpan = meta.rowspan || 0;

        const finalSpan = Math.max(valueSpan, styleSpan);

        // 하위 셀 숨김 처리
        for (let k = 1; k < finalSpan; k++) {
          if (cells[r + k]) {
            cells[r + k][0].hidden = true;
          }
        }
        cell.rowspan = finalSpan;
      }

      // 숨김 제외 후 반환
      return cells.map(row => row.filter(cell => !cell.hidden));
    },
  },
  methods: {
    formattedText,
    getHeaderStyle(colIndex) {
      const key = `-1, ${colIndex}`;
      const baseStyle = this.data_table_header_style;
      const option = this.selected_lang !== 'ENG' ? this.data_table_data?.options?.[key] : this.data_table_data?.translated?.options_e?.[key] || {};
      const mergedStyle = {
        ...baseStyle,
        ...option
      };


      const [top = 1, bottom = 1, left = 1, right = 1] = mergedStyle?.borderSide || [];

      return {
        border: `${mergedStyle?.borderWidth}px ${mergedStyle?.borderType} ${mergedStyle?.borderColor} !important`,
        'border-top': `${top ? 1 : 0} !important`,
        'border-bottom': `${bottom ? 1 : 0} !important`,
        'border-left': `${left ? 1 : 0} !important`,
        'border-right': `${right ? 1 : 0} !important`,

        backgroundColor: mergedStyle?.backgroundColor ? `${mergedStyle?.backgroundColor} !important` : null,
        width: `${mergedStyle.width}%`,
        verticalAlign: option?.verticalAlign ? `${option?.verticalAlign} !important` : 'top',
        textAlign: option?.textAlign ? `${option?.textAlign} !important` : 'start',
      };
    }

  }

};
</script>
